<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3>ATTIVITÀ</h3>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
        <div class="vx-card__body">
          <form v-on:submit.prevent="" data-vv-scope="attivita_lead">
            <vs-row>
              <vs-col v-if="azienda || contatto || lead" class="w-full px-2 mt-4">
                <label class="text-sm">{{['Origine',azienda ? 'Azienda' : contatto ? 'Contatto' : 'Lead'].join(' ')}}</label>
                <vs-input key="label_key" disabled v-model="fillLabel" class="w-full" name="mittente" placeholder="Inserisci la mail da cui hai ricevuto la mail" />
              </vs-col>
              <vs-col class="w-full px-2 mt-4">
                <label class="text-sm">Tipo Attività</label>
                <v-select key="tipo_key" disabled @option:created="formatOpt" taggable push-tags name="tipo" placeholder="Scegli l'attività da compiere" :options="tipo_list"  v-model="tipo"  ><span slot="no-options">Nessun risultato</span></v-select>
              </vs-col>
              <vs-col class="w-full px-2 mt-4" :key="tipokey+2">
                <label class="text-sm">Data di scadenza</label>
                <datepicker key="scad_key" typeable disabled placeholder="Seleziona la data di scadenza" :language="languages['it']" :format="datepicker_format" name="data_scadenza"  v-model="data_scadenza"/>
              </vs-col>
              <vs-col class="w-full px-2 mt-4" :key="tipokey+3">
                <label class="text-sm">Data di completamento</label>
                <datepicker key="complete_key" typeable disabled placeholder="Seleziona la data di completamento" :language="languages['it']" :format="datepicker_format" name="data_completamento" v-model="data_completamento"/>
              </vs-col>
              <vs-col v-if="orario_hh" class="md:w-1/3 w-full px-2 mt-6">
                <label class="mx-2">Orario fissato: {{orario_hh}}</label>
              </vs-col>
              <vs-col v-if="orario_fine_hh" class="md:w-1/3 w-full px-2 mt-6">
                <label class="mx-2">Orario termine: {{orario_fine_hh}}</label>
              </vs-col>
              <vs-col v-if="tipo.label == 'Mail'" class="vx-col w-full mt-6">
                <div class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="MailIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Gestisci la tua attività per mail</span>
                </div>
                <vs-divider />
                <vs-col class="md:w-1/2 w-full px-2 mt-2" :key="tipokey+4">
                  <label class="vs-input--label">Mittente</label>
                  <vs-input key="mitt_key" disabled v-model="mittente" class="w-full" name="mittente" placeholder="Inserisci la mail da cui hai ricevuto la mail" />
                </vs-col>
                <vs-col class="md:w-1/2 w-full px-2 mt-2" >
                  <label class="vs-input--label">Destinatario</label>
                  <vs-input key="dest_key" disabled v-model="destinatario" class="w-full" name="destinatario" placeholder="Inserisci la mail a chi hai inviato la mail" />
                </vs-col>
                <vs-col class="w-full px-2 mt-4">
                  <label class="vs-input--label">Mail</label>
                  <vs-textarea key="desc_key" disabled v-model="descrizione" placeholder="Inserisci il contenuto della mail" name="descrizione" />
                </vs-col>
              </vs-col>
              <vs-col v-if="tipo.label == 'Telefonata'" class="w-full px-2 mt-6">
                <div class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="PhoneCallIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Gestisci la tua attività per telefono</span>
                </div>
                <vs-divider />
                <vs-col class="w-full px-2 mt-2" :key="tipokey+5">
                  <label class="text-sm">Origine Telefonata</label>
                  <v-select disabled name="direzione_chiamata" placeholder="Scegli l'origine della telefonata" :options="direzione_chiamata_list"  v-model="direzione_chiamata"  ><span slot="no-options">Nessun risultato</span></v-select>
                </vs-col>
              </vs-col>
              <vs-col v-if="tipo.label != 'Mail'" class="w-full px-2 mt-4">
                <label class="text-sm">Descrivi l'attività</label>
                <vs-textarea key="desc2_key" disabled v-model="descrizione" placeholder="Scrivi i dettagli dell'attività da svolgere o terminata" name="descrizione" />
              </vs-col>
            </vs-row>
          </form>
        </div>
        <div class="vx-card__footer">
          <vs-row vs-type="flex" vs-justify="space-around">
            <vs-button v-if="this.id" @click="eliminaAttivitaLead($event)" icon-pack="feather" icon="icon-trash" color="danger" type="line" align="right">Elimina</vs-button>
          </vs-row>
        </div>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import axios from 'axios'
import vSelect from 'vue-select'
import Datepicker from '@sum.cumo/vue-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import VueTimepicker from 'vue2-timepicker'
// import '@sum.cumo/vue-datepicker/dist/vuejs-datepicker.css'

export default {
  data() {
    return {
      id: null,
      nome: "Attività",
      descrizione: "",
      tipo: "",
      data_scadenza: "",
      data_completamento: "",
      nome_creatore: "",

      orario_fine_hh: "",

      responsabile: null,
      responsabili: [],

      lead: null,
      leads: [],

      azienda: null,
      aziende: [],

      contatto: null,
      contatti: [],

      direzione_chiamata: null,
      direzione_chiamata_list: ['Ingresso', 'Uscita'],

      mittente: null,
      destinatario: null,

      radio_ca: 'more',

      tipo_list: [],
      // tipo_list: ['Telefonata', 'Mail', 'Appuntamento', 'Altro'].map(e => { return {label: e} }),

      datepicker_format: "d.MM.yyyy",
      languages: lang,

      formkey: null,
      tipokey: null,

      // appuntamento_orario: null,
      // appuntamento_orario_fine: null,
      fillLabel: "",
    }
  },

  props: {
    selected: Object,
    selected_date: Date,
    customer: Object,
    id_lead: Number,
    stato_lead: Object,
    altre_attivita: Array,
  },
  components: {
    vSelect,
    Datepicker,
    VueTimepicker,
  },
  mounted() {
    this.getUtenti()
    this.getTipoAtt()
    if (this.selected_date) {
      this.data_scadenza = this.selected_date
    }
    if (!this.id_lead) {
      this.getLeads()
    }
    this.formkey = Math.random()
    this.tipokey = Math.random()
    if (this.selected) {
      Object.keys(this.selected).forEach(e => this[e] = !this.selected[e] ? "" : this.selected[e])
      if(this.azienda) {
        this.azienda = this.selected.azienda
        this.azienda['label'] = `${this.azienda['ragione_sociale']} - ${this.azienda['codice_fiscale']}`
        this.fillLabel = this.azienda['label']
        this.radio_ca = 'az'
      }
      if(this.contatto) {
        this.contatto = this.selected.contatto
        this.contatto['label'] = `${this.contatto['nome']} ${this.contatto['cognome']}`
        this.fillLabel = this.contatto['label']
        this.radio_ca = 'con'
      }
      if(this.lead) {
        this.lead['label'] = `${this.lead['nome']}`
        this.fillLabel = this.lead['label']
        this.radio_ca = 'lea'
      }
      if(this.creatore) {
        this.nome_creatore = this.creatore['nome']
      }
      if(this.responsabile) {
        this.responsabile['label'] = this.responsabile['nome']
      }
      if(this.tipo) {
        this.tipo = {label: this.tipo}
      }
      // if (this.orario_hh && this.orario_mm) {
      //   this.appuntamento_orario = {}
      //   this.appuntamento_orario['orario_hh'] = this.orario_hh
      //   this.appuntamento_orario['orario_mm'] = this.orario_mm
      // }
      // if (this.orario_fine_hh && this.orario_fine_mm) {
      //   this.appuntamento_orario_fine = {}
      //   this.appuntamento_orario_fine['orario_hh'] = this.orario_fine_hh
      //   this.appuntamento_orario_fine['orario_mm'] = this.orario_fine_mm
      // }
    }
    else {
      this.nome_creatore = localStorage.utente_nome
    }
    if (localStorage.utente_nome) {
      this.utente_nome = localStorage.utente_nome
    }
    if (localStorage.utente_id) {
      this.utente_id = localStorage.utente_id
    }
  },

  methods: {
    formatOpt(opt) {
      opt.label = opt.label.charAt(0).toUpperCase() + opt.label.slice(1)
    },
    clearDate(ev) {
      this.data_completamento = ""
      ev.stopPropagation()
    },
    clearDateScad(ev) {
      this.data_scadenza = ""
      ev.stopPropagation()
    },
    getTipoAtt() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/board/tipi_attivita',{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      }).then(e => {
        if (e.data.filter(e => e.tipo === 'Altro').length == 0) {
          e.data.push({tipo: 'Altro'})
        }
        if (e.data.filter(e => e.tipo === 'Appuntamento').length == 0) {
          e.data.push({tipo: 'Appuntamento'})
        }
        if (e.data.filter(e => e.tipo === 'Telefonata').length == 0) {
          e.data.push({tipo: 'Telefonata'})
        }
        if (e.data.filter(e => e.tipo === 'Mail').length == 0) {
          e.data.push({tipo: 'Mail'})
        }
        this.tipo_list = e.data.map(e => {
          e['label'] = `${e['tipo']}`
          return e
        })
      }).catch(e => console.log(e))
    },
    getUtenti() {
      axios.post(process.env.VUE_APP_BACKEND_API+'/utente/trova', {
        pag: 1,
        keyword: '',
        take: 50
      },{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      })
      .then(e => {
        this.responsabili = e.data.res.map(e => {
          e['label'] = `${e['nome']}`+' '+`${e['cognome']}`
          return e
        })
      }).catch(e => console.log(e))
    },
    getLeads() {
      axios.post(process.env.VUE_APP_BACKEND_API+'/board/many_leads', {
        option: "Tutti",
        keyword: "",
      }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      }).then(response => { this.leads = response.data.map( l => {l['label'] = [l.nome,l.azienda ? l.azienda.ragione_sociale : [l.contatto.cognome,l.contatto.nome].join(' ')].join(' - ')
                                                                  return l}) }).catch(e => {console.log(e)})
    },
    eliminaAttivitaLead(ev) {
      this.$emit('elimina-attivita-lead', this.id)
      ev.stopPropagation()
    },
    closeSidebar(ev) {
      this.$emit('close-me')
      ev.stopPropagation()
    },
  },

  watch: {
    radio_ca() {
      this.formkey = Math.random()
    },
    tipo() {
      this.tipokey = Math.random()
    }
  },

  computed: {
    canEdit: {
      get() {
        return !this.id || +this.utente_id === +this.creatore.id || (this.amministratore && +this.utente_id === +this.amministratore.id) || this.$acl.check('admin')
      },
    }
  }
}
</script>
